<div class="col-sm-12 check-prestation" style="padding: 0px;">
  <div class="btn-group" role="group" aria-label="...">
      <button type="button" class="max" [ngClass]="{'btn-active': btnAffichage==='max'}" (click)="selectAffichage('max')">
          <img src="assets/images/icons/standard-max.svg" alt="max" width="100%" height="100%" *ngIf="btnAffichage !=='max'" />
          <img src="assets/images/icons/standard-max-active.svg" alt="max" width="100%" height="100%" *ngIf="btnAffichage ==='max'"/>
      </button>
      <button type="button" [ngClass]="{'btn-active': btnAffichage==='normal'}" (click)="selectAffichage('normal')">
          <i class="fa fa-bars" aria-hidden="true"></i>
      </button>
      <button type="button" class="min" [ngClass]="{'btn-active': btnAffichage==='min'}" (click)="selectAffichage('min')">
          <img src="assets/images/icons/standard-min.svg" alt="min" width="100%" height="100%" *ngIf="btnAffichage !=='min'"/>
          <img src="assets/images/icons/standard-min-active.svg" alt="min" width="100%" height="100%" *ngIf="btnAffichage ==='min'"/>
      </button>
  </div>
</div>